import "./Cart.module.css";
import HeaderPrincipale from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import FooterInformativo from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <HeaderPrincipale />
      <CartContent />
      <FooterInformativo />
    </div>;
}